import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  users: null,

  fetchError: null,
  fetchLoader: null,
  fetchSuccess: false,

  suspendUserDetails: {},
  suspendUserErrors: null,
  suspendUserSuccess: false,
  suspendUserLoader: false,
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {

    case ACTIONS_TYPES.FETCH_USERS_REQUEST:
      return { ...state, fetchLoader: true, fetchError: null, fetchSuccess: false };

    case ACTIONS_TYPES.FETCH_USERS_SUCCESS:
      return { ...state, users: action.payload, fetchLoader: false, fetchSuccess: true };

    case ACTIONS_TYPES.FETCH_USERS_FAILED:
      return { ...state, fetchLoader: false, fetchError: action.payload };

    case ACTIONS_TYPES.SUSPEND_USER_REQUEST:
      return { ...state, suspendUserLoader: true, suspendUserErrors: null, suspendUserSuccess: false };

    case ACTIONS_TYPES.SUSPEND_USER_SUCCESS:
      return { ...state, suspendUserDetails: action.payload, suspendUserLoader: false, suspendUserSuccess: true };

    case ACTIONS_TYPES.SUSPEND_USER_FAILED:
      return { ...state, suspendUserLoader: false, suspendUserErrors: action.payload };  

    case ACTIONS_TYPES.SUSPEND_USER_RESET:
      return { ...state,  suspendUserErrors: null, suspendUserSuccess: false };
      
    case ACTIONS_TYPES.FETCH_USERS_RESET:
      return { ...initialState  };

    default:
      return state;
  }
}